// ** Initial State
const initialState = {
  allData: [],
  data: [],
  categoryData: null,
  categoriesWithPagination: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case "DELETE_DATA":
      return { ...state, data: action.data };
    case "GET_ALL_CATEGORIES_PAGINATED_DATA":
      return { ...state, categoriesWithPagination: action.data };
    case "GET_CATEGORY_DATA":
      return { ...state, categoryData: action.data };
    case "CREATE_CATEGORY":
      return { ...state, data: action.data };
    case "UPDATE_CATEGORY":
      return { ...state, data: action.data };
    default:
      return { ...state };
  }
};
export default categories;
